enum UpdateForecastFormNames {
  NewForecastTitle = 'New Forecast Value (Hours)',
  NewForecast = 'forecastLength',
  UpdateForecastTitle = 'Update Forecast'
}

export default UpdateForecastFormNames;
